const gccsSettingsBillingRecipients = {
  template: require('./template.html'),
  controller: 'SettingsBillingRecipientsController',
  controllerAs: 'settingsBillingRecipientsCtrl'
};

angular.module('public.security-manager.settings')
  .component('gccsSettingsBillingRecipients', gccsSettingsBillingRecipients);
